const endpoints = {
  spotify: '/.netlify/functions/spotify',
  contact: 'https://api.hsforms.com/submissions/v3/integration/submit',
};

export default endpoints;
